module.exports = __webpack_public_path__ + "static/img/F.03d9300.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl/F.png
// module id = S+E+
// module chunks = 0